import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { I18n } from 'react-redux-i18n'
import { Input, Label } from 'reactstrap'

/**
 * Input that allows you to choose between a range of dates or a single date.
 * - Date format: '2016-01-02'
 *
 * @param {Function} onChange
 * onChange(String|Array, name), is required.
 * When the user interacts with their component (that is, selects a date), this function is called.
 * Within the function, two parameters arrive:
 *    - date, an array if range is true, or an string if range is false or default.
 *  - name, name for your form component
 * You must assign the new date to your component.
 *
 * @param {Boolean} range
 * Default false.
 * Set the component as a range or a simple date field.
 *
 * @param {String} init
 * Is required.
 * Set the current start date selected for your component.
 *
 * @param {String} end
 * Set the current end date selected for your component.
 *
 * @param {String} max
 * Default current date.
 * Set the maximum allowed date that can be selected for your component
 *
 * @param {String} min
 * Default 2016-01-01.
 * Set the minimum allowed date that can be selected for your component
 *
 * @param {String} className
 * Add a className for your component
 *
 * @param {String} label
 * Set a label for your form component
 *
 * @param {String} name
 * Set a name for your form component
 */
export default class InputDateRange extends Component {
  constructor(props) {
    super(props)

    this.onDateInitChange = this.onDateInitChange.bind(this)
    this.onDateEndChange = this.onDateEndChange.bind(this)
  }

  onDateInitChange({ target }) {
    const { range = false, end, init, name } = this.props
    const date = target.value

    if (init === date) return
    if (!range) {
      return this.props.onChange(init, name)
    }

    this.props.onChange([date || init, end], name)
  }

  onDateEndChange({ target }) {
    const { end, init, name } = this.props
    const date = target.value

    if (end === date) return

    this.props.onChange([init, date || end], name)
  }

  render() {
    const { label, range, init, end, min, max, className, name } = this.props
    return (
      <div className={`date_range ${className}`} name={name}>
        {label && <Label for='date-range'>{I18n.t(label)}</Label>}
        <div className='date_range-date_init'>
          {range && <span className='date_range-from'>{I18n.t('dashboard_from')}</span>}
          <Input type='date' className='date_range-input_init' min={min} max={end || max} value={init} onChange={this.onDateInitChange} />
        </div>
        {range && (
          <div className='date_range-date_end'>
            <span className='date_range-to'>{I18n.t('dashboard_until')}</span>

            <Input type='date' className='date_range-input_end' min={init || min} value={end} max={max} onChange={this.onDateEndChange} />
          </div>
        )}
      </div>
    )
  }
}

InputDateRange.propTypes = {
  className: PropTypes.string,
  end: PropTypes.string,
  init: PropTypes.string.isRequired,
  label: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  range: PropTypes.bool,
}

InputDateRange.defaultProps = {
  className: '',
  end: '',
  init: '',
  label: '',
  max: new Date().toISOString().split('T')[0],
  min: '2016-01-01',
  name: '',
  range: false,
}
